///
/// EarthBrowser
///
/// Created by Matt Giger on 9/18/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Location-based alert rules (subscription feature): one rule per
/// placemark, keyed by placemark id. The server evaluates rules hourly
/// against active CAP weather alerts and emails when a member location
/// is newly covered. The client only manages the rules.
///
import type {
	ListPlacemarkAlertsResponse,
	PlacemarkAlertRuleRecord,
	PutPlacemarkAlertRequest,
} from "@shared-types"
import { authenticatedApi } from "./API/authenticatedApi"

export const placemarkAlertsApi = authenticatedApi.injectEndpoints({
	endpoints: (builder) => ({
		listPlacemarkAlerts: builder.query<ListPlacemarkAlertsResponse, void>({
			query: () => "/api/user/placemark-alerts",
			providesTags: ["PlacemarkAlerts"],
		}),
		putPlacemarkAlert: builder.mutation<{ rule: PlacemarkAlertRuleRecord }, { placemarkId: string } & PutPlacemarkAlertRequest>({
			query: ({ placemarkId, ...body }) => ({
				url: `/api/user/placemark-alerts/${placemarkId}`,
				method: "PUT",
				body,
			}),
			invalidatesTags: ["PlacemarkAlerts"],
		}),
		deletePlacemarkAlert: builder.mutation<{ success: boolean }, string>({
			query: (placemarkId) => ({
				url: `/api/user/placemark-alerts/${placemarkId}`,
				method: "DELETE",
			}),
			invalidatesTags: ["PlacemarkAlerts"],
		}),
	}),
})

export const {
	useListPlacemarkAlertsQuery,
	usePutPlacemarkAlertMutation,
	useDeletePlacemarkAlertMutation,
} = placemarkAlertsApi
